import { render, staticRenderFns } from "./WebTwoTrainPlanDatabaseSub.vue?vue&type=template&id=f687d886&scoped=true&"
import script from "./WebTwoTrainPlanDatabaseSub.vue?vue&type=script&lang=js&"
export * from "./WebTwoTrainPlanDatabaseSub.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoTrainPlanDatabaseSub.vue?vue&type=style&index=0&id=f687d886&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f687d886",
  null
  
)

export default component.exports